export const Config = {
	BACKEND_BASE_URL:
		"https://accio-matrix-eobnd7jx2q-el.a.run.app",
	// BACKEND_BASE_URL: "http://localhost:5009",
	WS_BASE_URL:
		"wss://interview-api.acciomatrix.com/client-websocket",
};
